import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"
import "./button.css"

const buttonVariants = cva(
  "ischart-button",
  {
    variants: {
      variant: {
        default: "ischart-button--default",
        destructive: "ischart-button--destructive",
        outline: "ischart-button--outline",
        secondary: "ischart-button--secondary",
        info: "ischart-button--info",
        success: "ischart-button--success",
        ghost: "ischart-button--ghost",
        link: "ischart-button--link",
      },
      size: {
        default: "",
        sm: "ischart-button--sm",
        lg: "ischart-button--lg",
        icon: "ischart-button--icon",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
  }) {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Button, buttonVariants }
